<template>
  <div id="jumbotron">
    <div class="container">
      <h1 v-html="$t('creativeWritingPage.title')"></h1>
    </div>
  </div>

  <div class="container pt-5">
    <h2 class="text-primary">{{ $t('creativeWritingPage.subTitle') }}</h2>
    <div class="yt-container">
      <iframe width="560" height="315" src="https://www.youtube.com/embed/nw3kjL0QrWw?si=LennlpPcc1efLPk4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>
  </div>

  <div class="container py-5">
    <div class="row m-0">
      <div class="col-12 col-md-6 text-center">
        <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/Classes+Creative+Writing.webp"
            alt="Creative Writing Class" class="w-100">
      </div>
      <div id="description" class="col-12 col-md-6" v-html="$t('creativeWritingPage.description')"></div>
    </div>
  </div>
  <ContactUs />
</template>

<style scoped>
#jumbotron {
  background-color: #2e1aaf;
  background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/celebration.png");
  background-size: cover;
  background-position: right bottom -200px;
  background-repeat: no-repeat;
  padding-top: 20vh;
  color: white;
  height: 55vh;
}

.container { max-width: 1100px; }

h1 { font-size: 3.5em; }
h2 { font-size: 3em; max-width: 900px; margin: auto; }

.yt-container {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 aspect ratio (height = width * 9/16) */
}

.yt-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

img {
  max-width: 450px;
  margin: auto;
  text-align: center;
}

#description {
  font-size: 1.4em;
}
</style>

<script>
import ContactUs from '../components/ContactUs.vue';
export default {
  components: { ContactUs }
}
</script>